import React, { Component } from 'react';
import { PrimaryButton, DLTextField } from 'appSrc/components/UI';
import { YOUTUBE_URI_REGEX, FACEBOOK_URI_REGEX, YOUTUBE_CHANNEL_REGEX } from 'appSrc/utils/video';
import style from './styles/style.module.css';


class StepLink extends Component {
    state = {
        videoLink: '',
    }
    updateVideoLink = ( evt, { value } ) => {
        this.setState( { videoLink: value } );
    }
    testLink = () => {
        var url = this.state.videoLink;
        var ret = {};
        ret.value = {
            uri: url,
        };

        if( YOUTUBE_URI_REGEX.test( url ) ) {
            // functional youtube link
            ret.next = 'next';
            ret.id = url.match( YOUTUBE_URI_REGEX )[ 1 ];
            ret.value.source = 'youtube';
        } else if( FACEBOOK_URI_REGEX.test( url ) ) {
            // functional facebook link
            ret.next = 'next';
            ret.value.source = 'facebook';
        } else {
            // not a direct link, so it's probably a channel instead
            // either way, this is going to require some finagling
            if( YOUTUBE_CHANNEL_REGEX.test( url ) ) {
                // it's a youtube channel
                ret.next = 'schedule_link_check';
                ret.value.source = 'youtube';
                let query = {};
                let m = url.match( YOUTUBE_CHANNEL_REGEX );
                if( m[1] == 'channel' ) {
                    query.channelId = m[ 2 ];
                } else {
                    query.channelName = m[ 2 ];
                }
                ret.query = query;
            }
        }
        this.props.onSubmit( ret );
    }
    render() {
        const inlineStyle = this.props.step !== 'video_uri' ? { display: 'none' } : {};

        return (
            <div className={ `${ style.step } ${ style.videoLink }` } style={ inlineStyle }>
                <div className={ style.question }>
                    Please enter the video URL?
                </div>
                <DLTextField value={ this.state.videoLink }
                onChange={ this.updateVideoLink }
                fullWidth autoFocus />
                <div className={ style.buttonGroup }>
                    <PrimaryButton label='Go' disabled={ !this.state.videoLink } onClick={ this.testLink }/>
                </div>
            </div>
        );
    }
}
StepLink.defaultProps = {
    onSubmit: () => {},
};

export default StepLink;
